export default __webpack_public_path__ + "static/media/SWT0410.34I-36796_-21626_0.ecdfe54e.jpg";